import ReactDOMServer from "react-dom/server";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { GiPositionMarker } from "react-icons/gi";

// Scoped styles for this map only
const mapWrapperStyle = `
    .simple-map-wrapper .leaflet-control-zoom {
      display: none !important;
    }
  `;

// Create custom icon using GiPositionMarker
const customIcon = L.divIcon({
  html: ReactDOMServer.renderToString(
    <GiPositionMarker style={{ color: "#b6a87d", fontSize: "32px" }} />,
  ),
  className: "custom-marker-icon",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

// Marino center coordinates
const center = [41.7659193, 12.6117065];

// Keep current business location/address
const markers = [
  {
    position: [41.7659193, 12.6117065],
    title: "Ferro Marrocco",
    description: "Via Luigi Einaudi 10, Marino RM",
  },
];

export default function SimpleMap() {
  return (
    <div
      className="simple-map-wrapper relative"
      style={{ width: "100%", height: "35vh" }}
    >
      <style>{mapWrapperStyle}</style>
      <MapContainer
        center={center}
        zoom={15.5}
        scrollWheelZoom={false}
        dragging={false}
        doubleClickZoom={false}
        touchZoom={false}
        boxZoom={false}
        keyboard={false}
        attributionControl={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {markers.map((marker, index) => (
          <Marker key={index} position={marker.position} icon={customIcon}>
            <Popup>
              <h2>{marker.title}</h2>
              <p>{marker.description}</p>
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      <div className="pointer-events-auto absolute bottom-2 left-2 z-[500] rounded bg-white/85 px-2 py-1 text-[10px] text-gray-700">
        &copy;{" "}
        <a
          href="https://www.openstreetmap.org/copyright"
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          OpenStreetMap
        </a>{" "}
        contributors
      </div>
    </div>
  );
}
